export class PlayerOutputTypes {
	Id: number;
	Description: string;

	name: string;
}